import {Button, Flex, Icon, Spinner, Text, VStack} from "@chakra-ui/react";
import {HiOutlineCog6Tooth} from "react-icons/hi2";
import {useEffect, useState} from "react";
import ConfigureEndpointModal from "@/pages/endpoints/components/ConfigureEndpointModal";
import EndpointService from "@/services/agency/EndpointService";
import EndpointListItem from "@/components/ui/endpoints/EndpointListItem";
import {useEndpointContext} from "@/components/providers/EndpointProvider";

const EndpointsPage = () => {
    const { endpointObjects, isLoading, refresh } = useEndpointContext();
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [endpoints, setEndpoints] = useState([])
    const [selectedEndpoint, setSelectedEndpoint] = useState(null)

    useEffect(() => { setEndpoints(endpointObjects); }, [endpointObjects])
    
    const handleEdit = (endpoint) => {
        setSelectedEndpoint(endpoint)
        setIsModalOpen(true)
    }

    const handleAdd = () => {
        setSelectedEndpoint(null)
        setIsModalOpen(true)
    }

    const handleClose = () => {
        setIsModalOpen(false)
        setSelectedEndpoint(null)
    }

    const handleSave = (data) => {
        if (data.id) {
            return EndpointService.update(data).then(updated => {
                setEndpoints(prev => prev.map(e => e.id === updated.id ? updated : e))
                refresh()
            })
        } else {
            return EndpointService.create(data).then(created => {
                setEndpoints(prev => [...prev, created])
                refresh()
            })
        }
    }

    if (isLoading) {
        return (
            <Flex w={'full'} py={24} alignItems={'center'} justifyContent={'center'}>
                <Spinner size={'xl'} color={'white'}/>
            </Flex>
        )
    }

    return (
        <VStack w={'full'} rowGap={6}>
            <Flex flexDirection={'row'} justifyContent={'flex-end'} w={'full'}>
                <Button variant="primary" textDecoration='unset' onClick={handleAdd}>
                    <Icon fontSize={46}>
                        <HiOutlineCog6Tooth/>
                    </Icon>
                    <Text>Configure Endpoint</Text>
                </Button>
            </Flex>
            {endpoints.map(endpoint => (
                <EndpointListItem key={endpoint.id} endpoint={endpoint} onEdit={handleEdit}/>
            ))}
            <ConfigureEndpointModal
                isOpen={isModalOpen}
                onClose={handleClose}
                onSave={handleSave}
                endpoint={selectedEndpoint}
                endpoints={endpoints}
            />
        </VStack>
    )
}

export default EndpointsPage;
